import { useCallback, useState } from 'react'

export function useRotation() {
  const [rotationMap, setRotationMap] = useState<Map<number, number>>(new Map())

  const getRotation = useCallback(
    (pageNumber: number) => {
      return rotationMap.get(pageNumber) ?? 0
    },
    [rotationMap],
  )

  const rotateLeft = useCallback((pageNumber: number) => {
    setRotationMap((prev) => {
      const newMap = new Map(prev)
      const currentRotation = prev.get(pageNumber) ?? 0
      const newRotation = (currentRotation - 90 + 360) % 360
      newMap.set(pageNumber, newRotation)
      return newMap
    })
  }, [])

  const rotateRight = useCallback((pageNumber: number) => {
    setRotationMap((prev) => {
      const newMap = new Map(prev)
      const currentRotation = prev.get(pageNumber) ?? 0
      const newRotation = (currentRotation + 90) % 360
      newMap.set(pageNumber, newRotation)
      return newMap
    })
  }, [])

  return {
    getRotation,
    rotateLeft,
    rotateRight,
  }
}
